export enum ConfigurationTab {
  Mapping = 'Mapping',
  General = 'General',
  Teams = 'Teams',
  Script = 'Script'
}
